import Button from "../../../lib/ui/controls/Button";
import { C } from "../../../lib/ui/constructors";
var cls = C.cls;
export class BigNisButton extends Button {
    constructor(text, style) {
        super();
        this.content_container = c().text(text).addClass("content").appendTo(this);
        cls("background").appendTo(this);
        this.addClass("nisl-big-button");
        this.addClass(`nisl-big-button-${style}`);
    }
    setContent(content) {
        this.content_container.empty().append(content);
        return this;
    }
}
